<template>
  <div>
    <!-- :before-close="handleClose" -->
    <el-drawer
      :title="title"
      :visible.sync="drawer"
      size="90%"
      :wrapperClosable="false"
    >
      <div class="form-center" v-loading="loading">
        <el-form :model="form" ref="form" label-width="130px" :rules="rules">
          <el-row>
            <el-col :span="8">
              <el-form-item label="处置单号" prop="ScrapCode">
                <el-input
                  v-model="form.ScrapCode"
                  :disabled="disabled"
                  placeholder="请输入处置单号"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="处置日期" prop="ScrapDate">
                <el-date-picker
                  v-model="form.ScrapDate"
                  :disabled="disabled"
                  value-format="yyyy-MM-dd"
                  type="date"
                  style="width: 100%"
                  placeholder="请选择日期"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="处置类型" prop="ScrapType">
                <el-select
                  v-model="form.ScrapType"
                  :disabled="disabled"
                  placeholder="请选择"
                  style="width: 100%"
                  clearable
                  filterable
                >
                  <el-option
                    v-for="item in ScrapTypeList"
                    :key="item.Value"
                    :label="item.Name"
                    :value="item.Value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="资产编号" prop="AssetCode">
                <div style="width: 100%; display: flex; align-items: center">
                  <el-input
                    v-model="form.AssetCode"
                    placeholder="请选择资产"
                    disabled
                    style="width: calc(100% - 60px)"
                  ></el-input>
                  <el-button
                    style="width: 60px"
                    :disabled="disabled"
                    type="primary"
                    @click="openAsset"
                    ><i class="el-icon-search"></i
                  ></el-button>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="资产名称" prop="AssetName">
                <el-input
                  v-model="form.AssetName"
                  disabled
                  placeholder="请输入资产名称"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="原值" prop="OriginalValue">
                <el-input
                  v-model="form.OriginalValue"
                  disabled
                  type="number"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                label="累计折旧月"
                prop="AccumulatedDepreciationMonths"
              >
                <el-input
                  v-model="form.AccumulatedDepreciationMonths"
                  disabled
                  type="number"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="累计折旧" prop="AccumulatedDepreciation">
                <el-input
                  v-model="form.AccumulatedDepreciation"
                  disabled
                  type="number"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="净值" prop="NetValue">
                <el-input
                  v-model="form.NetValue"
                  disabled
                  type="number"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="残值" prop="NetSalvage">
                <el-input
                  v-model="form.NetSalvage"
                  disabled
                  type="number"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="变动值" prop="ChangeAmount">
                <el-input
                  v-model="form.ChangeAmount"
                  :disabled="disabled"
                  type="number"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="评估后值" prop="EvaluationValue">
                <el-input
                  v-model="form.EvaluationValue"
                  :disabled="disabled"
                  type="number"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="处置收入" prop="NonOperatingIncome">
                <el-input
                  v-model="form.NonOperatingIncome"
                  :disabled="disabled"
                  type="number"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="清理费用" prop="CleaningUpCost">
                <el-input
                  v-model="form.CleaningUpCost"
                  :disabled="disabled"
                  type="number"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="处置人" prop="DisposalPerson">
                <el-input
                  v-model="form.DisposalPerson"
                  :disabled="disabled"
                  placeholder="处置人"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="是否折旧" prop="DepreciationStatus">
                <el-radio-group
                  v-model="form.DepreciationStatus"
                  :disabled="disabled"
                >
                  <el-radio :label="0">否</el-radio>
                  <el-radio :label="1">是</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="16">
              <el-form-item label="备注" prop="Remark">
                <el-input
                  v-model="form.Remark"
                  placeholder=""
                  :disabled="disabled"
                  type="textarea"
                  rows="3"
                  resize="none"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="附件" prop="ProjectImg">
                <el-upload
                  class="avatar-uploader"
                  :disabled="disabled"
                  :action="
                    $rootUrl +
                    `/Base_Manage/Upload/ProjectOssUploadFileByForm?Type=5`
                  "
                  :headers="{
                    Authorization: token,
                  }"
                  :show-file-list="false"
                  :on-success="handleAvatarSuccess"
                  :before-upload="beforeAvatarUpload"
                >
                  <el-image
                    v-if="form.AttachmentUrl"
                    fit="contain"
                    class="projectImg"
                    :src="form.AttachmentUrl"
                  ></el-image>
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div class="footer" v-loading="loading">
        <el-button @click="close">取消</el-button>
        <el-button type="primary" v-if="!disabled" @click="handleSubmit(0)"
          >保存</el-button
        >
        <el-button type="primary" v-if="!disabled" @click="handleSubmit(1)"
          >提交</el-button
        >
      </div>
    </el-drawer>
    <AssetDialog
      ref="AssetDialog"
      @select="handleAssetSelect"
      type="radio"
    ></AssetDialog>
  </div>
</template>
<script>
import Token from '@/utils/cache/TokenCache.js'
import AssetDialog from '@/components/AssetDialog/AssetDialog.vue'

export default {
  data() {
    return {
      title: '',
      loading: false,
      disabled: false,
      token: 'Bearer ' + Token.getToken(),
      ScrapTypeList: [],
      form: {
        ScrapCode: '',
        ScrapDate: '',
        ScrapType: '',
        NetValue: '',
        NetSalvage: '',
        OriginalValue: '',
        ChangeAmount: '',
        EvaluationValue: '',
        NonOperatingIncome: '',
        CleaningUpCost: '',
        AssetId: '',
        DisposalPerson: '',
        ScrapRemarks: '',
        AssetCode: '',
        AttachmentUrl: '',
        Status: 0,
        DepreciationStatus: 0,
      },
      rules: {
        ScrapCode: [
          { required: true, message: '请输入处置单号', trigger: 'blur' },
        ],
        ScrapDate: [
          { required: true, message: '请选择处置日期', trigger: 'change' },
        ],
        ScrapType: [
          { required: true, message: '请选择处置类型', trigger: 'change' },
        ],
        AssetCode: [
          { required: true, message: '请选择资产', trigger: 'change' },
        ],
        IsEnabled: [
          { required: true, message: '请选择停/启用', trigger: 'change' },
        ],
      },
      drawer: false,
    }
  },
  components: { AssetDialog },
  props: {},
  methods: {
    handleSubmit(Status) {
      this.$set(this.form, 'Status', Status)
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return this.$notify.error('请检查输入项')
        }
        this.loading = true
        this.$http
          .post('/AM/AM_AssetDisposal/SaveData', this.form)
          .then((resJson) => {
            this.loading = false

            if (resJson.Success) {
              this.$notify.success('操作成功!')
              this.$emit('success')
              this.close()
            } else {
              this.$notify.error(resJson.Msg)
            }
          })
      })
    },
    handleAssetSelect(arr) {
      console.log(3)
      console.log(arr)
      console.log(2)
      this.$set(this.form, 'AssetId', arr[0].Id)
      this.$set(this.form, 'OriginalValue', arr[0].OriginalValue)
      this.$set(this.form, 'ChangeAmount', arr[0].ChangeAmount)
      this.$set(this.form, 'EvaluationValue', arr[0].EvaluationValue)
      this.$set(this.form, 'ChangeAmount', arr[0].ChangeAmount)
      this.$set(this.form, 'AssetCode', arr[0].AssetCode)
      this.$set(this.form, 'AssetName', arr[0].AssetName)
      this.$set(
        this.form,
        'AccumulatedDepreciation',
        arr[0].AccumulatedDepreciation
      )
      this.$set(
        this.form,
        'AccumulatedDepreciationMonths',
        arr[0].AccumulatedDepreciationMonths
      )
      this.$set(this.form, 'NetValue', arr[0].NetValue)
      this.$set(this.form, 'NetSalvage', arr[0].NetSalvage)
      console.log(1)
      console.log(this.form)
      // this.$set(
      //     this.form,
      //     "DeviceItemNameJson",
      //     `${this.form.DeviceItemName}(${this.form.DeviceItemCode})`
      // );
    },
    openAsset() {
      this.$refs.AssetDialog.openDialog()
    },
    handleAvatarSuccess(res, file) {
      console.log(res, file)
      if (res.code == 200) {
        this.$set(this.form, 'AttachmentUrl', res.url)
        // this.form.Icon = res.url;
      } else {
        this.$notify.error(res.Msg)
      }
    },
    beforeAvatarUpload(file) {
      //const isJPG = file.type === "image/jpeg" || file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 20

      // if (!isJPG) {
      //   this.$notify.error("上传图片只能是 JPG 或 PNG 格式!");
      // }
      if (!isLt2M) {
        this.$notify.error('上传头像图片大小不能超过 20MB!')
      }
      return isLt2M
    },
    getScrapType() {
      this.$http
        .post('/Base/Base_EnumItem/GetListByCode', {
          id: 'AssetStatus',
        })
        .then((res) => {
          if (res.Success) {
            this.ScrapTypeList = res.Data
          } else {
            this.ScrapTypeList = []
          }
        })
    },
    openForm(title, id, flag) {
      this.disabled = flag
      this.drawer = true
      this.getScrapType()
      this.form = {
        ScrapCode: '',
        ScrapDate: '',
        ScrapType: '',
        NetValue: '',
        NetSalvage: '',
        OriginalValue: '',
        ChangeAmount: '',
        EvaluationValue: '',
        NonOperatingIncome: '',
        CleaningUpCost: '',
        AssetId: '',
        DisposalPerson: '',
        ScrapRemarks: '',
        AssetCode: '',
        AttachmentUrl: '',
        Status: 0,
        DepreciationStatus: 0,
      }
      this.$nextTick(() => {
        this.$refs.form.resetFields()
      })
      this.title = title
      this.getInfo(id)
    },
    getInfo(id) {
      this.loading = true
      if (id != null) {
        this.$http
          .post('/AM/AM_AssetDisposal/GetTheData', { id: id })
          .then((resJson) => {
            this.loading = false
            if (resJson.Success) {
              this.form = resJson.Data
            } else {
              this.$notify.error(resJson.Msg)
            }
          })
      } else {
        this.loading = false
      }
    },
    close() {
      this.drawer = false
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then(() => {
          done()
        })
        .catch(() => {})
    },
  },
  mounted() {},
  created() {},
  computed: {},
  watch: {},
}
</script>
<style lang="scss" scoped>
::v-deep .el-drawer__header {
  margin: 0;
  padding: 20px;
}
.form-center {
  height: calc(100vh - 120px);
  padding: 20px;
}
.footer {
  height: 40px;
  line-height: 40px;
  text-align: right;
  padding: 0 20px;
}
::v-deep .avatar-uploader .el-upload {
  width: 100px;
  height: 100px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

::v-deep .avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 65px;
  height: 60px;
  line-height: 60px;
  text-align: center;
}
</style>
